import { ClientStatus } from '../../../../model/ClientStatus';
import { useClientFetch } from '../../../../context/ClientStatusContext';
import { fetchSablonaStadiumList } from '../../../../client/external/ciselniky/sablonaStadiumClient';
import { StadiumMaterialu } from '../../../../model/legislativnyMaterial/StadiumMaterialu';

interface ReturnType {
  stadiumList: Array<StadiumMaterialu>;
  stadiumStatus: ClientStatus;
}

export default (sablonaUuid: string): ReturnType => {
  const {
    data: stadiumList,
    status: stadiumStatus,
  } = useClientFetch(
    fetchSablonaStadiumList,
    [sablonaUuid],
    [],
  );
  return {
    stadiumList,
    stadiumStatus,
  };
};
